import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=f60b9704&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SelectInstructor: require('/opt/buildhome/repo/components/select-instructor/index.vue').default,Button: require('/opt/buildhome/repo/components/global/Button.vue').default})
